module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('Panel', {}, [_vm._c('PanelHeading', {
    attrs: {
      "title": "subject.title",
      "subtitle": _vm.chapters.length + ' chapter' + (_vm.chapters.length > 1 ? 's' : '')
    }
  }, [_vm._c('div', {
    slot: "title"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('span', {
    staticClass: "expandButton",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [_vm._v(_vm._s(_vm.subject.title))]), _vm._v(" "), _vm._c('span', {
    staticClass: "expandButton",
    on: {
      "click": _vm.toggleExpanded
    }
  }, [(_vm.expanded) ? _vm._c('span', {
    staticClass: "icon mdi mdi-chevron-down"
  }) : _vm._c('span', {
    staticClass: "icon mdi mdi-chevron-right"
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('button', {
    staticClass: "btn btn-default select-all",
    on: {
      "click": function($event) {
        _vm.selectAll()
      }
    }
  }, [_vm._v("Select all")])])])])]), _vm._v(" "), (_vm.expanded) ? _vm._c('PanelBody', _vm._l((_vm.chapters), function(chapter) {
    return _vm._c('div', [_vm._c('ChapterRow', {
      attrs: {
        "chapter": chapter
      }
    })], 1)
  })) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-182a9524!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-exporter/SubjectRow.vue
// module id = 627
// module chunks = 1